import React, { useEffect, useState } from "react";
import toursData from "../../API/tours";
import { useNavigate, useLocation } from "react-router-dom";
import Loading from "../loading/Loading";
import "./Card.css";

const Card = ({ filters, setFilters }) => {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const packageFromURL = params.get("package");

    if (packageFromURL) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        packageFilter: packageFromURL,
      }));
    }
  }, [location.search, setFilters]);

  // Fetch tours data on component mount
  useEffect(() => {
    setTours(toursData);
  }, []);

  // Filter logic with priceRange
  const filteredTours = tours.filter((tour) => {
    const { location, priceRange, typeOfTour, packageFilter, hotel } = filters;

    const matchesLocation = !location || tour.location === location;

    const matchesTypeOfTour = !typeOfTour || tour.typeOfTour === typeOfTour;

    const matchesPackage = !packageFilter || tour.package === packageFilter;

    const matchesHotel = !hotel || tour.hotel === hotel;

    const matchesPriceRange = (() => {
      if (!priceRange) return true;

      switch (priceRange) {
        case "below-5000":
          return tour.basePrice < 5000;
        case "5000-10000":
          return tour.basePrice >= 5000 && tour.basePrice <= 10000;
        case "10000-15000":
          return tour.basePrice > 10000 && tour.basePrice <= 15000;
        case "above-15000":
          return tour.basePrice > 15000;
        default:
          return true;
      }
    })();

    return (
      matchesLocation &&
      matchesTypeOfTour &&
      matchesPackage &&
      matchesHotel &&
      matchesPriceRange
    );
  });

  // Group tours by typeOfTour
  const groupedTours = filteredTours.reduce((acc, tour) => {
    if (!acc[tour.typeOfTour]) {
      acc[tour.typeOfTour] = [];
    }
    acc[tour.typeOfTour].push(tour);
    return acc;
  }, {});

  const handleCardClick = (tourName) => {
    setLoading(true); // Show loading component

    setTimeout(() => {
      const formattedName = tourName.replace(/\s+/g, "-").toLowerCase();
      navigate(`/tours/${formattedName}`);
      window.scrollTo(0, 0);
      setLoading(false); // Hide loading component after navigation
    }, 1000); // Adjust delay if needed
  };
  return (
    <div className="cardMainContainer">
      {loading && <Loading />}
      <section className="card-section">
        <h2>Most Popular Tours</h2>
        <p>
          Discover our most popular tours and travel packages that promise an
          unforgettable experience.
        </p>

        {Object.keys(groupedTours).length > 0 ? (
          Object.keys(groupedTours).map((typeOfTour, index) => (
            <div key={typeOfTour}>
              <h3
                className="typeOfTour-heading"
                style={index !== 0 ? { marginBlock: "30px 0" } : {}}
              >
                {typeOfTour}
              </h3>
              <div className="card-grid">
                {groupedTours[typeOfTour].map((tour) => (
                  <div
                    className="card-item"
                    key={tour.id}
                    onClick={() => handleCardClick(tour.name)}
                  >
                    <img
                      src={tour.imgArray[0]}
                      alt={tour.name}
                      className="card-img"
                      loading="lazy"
                    />
                    <div className="card-text">
                      <h3>{tour.name}</h3>
                      <p>{tour.desc}</p>
                      <div className="card-details">
                        <span className="card-price">₱{tour.basePrice}</span>
                        <span className="card-rating">⭐ {tour.rating}</span>
                      </div>
                      <div className="card-botDesc">
                        <span>{tour.typeOfTour} Tour</span>
                        <span>{tour.days}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <p className="no-tours-message">No available tours / packages</p>
        )}
      </section>
    </div>
  );
};

export default Card;
